import React from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import ContentSection from '../components/landing/ContentSection';
import ThreeSteps from '../components/landing/ThreeSteps';
import Principles from '../components/landing/Principles';
import FAQ from '../components/landing/FAQ';
import HighlightsTable from '../components/landing/HighlightsTable';
import Footer from '../components/landing/Footer';
import { siteData } from '../data/mock';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Header />
      <Hero />

      {/* Content Sections 1-3 with background image pattern */}
      <div id="chi-siamo" className="relative">
        <div className="absolute inset-0 bg-gradient-to-b from-[#f0f4ff]/30 to-transparent pointer-events-none" />
        
        {siteData.sections.map((section) => (
          <ContentSection
            key={section.id}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            imageLeft={section.imageLeft}
            isQuote={section.isQuote}
          />
        ))}
      </div>

      {/* Benefit Section - Dark BG */}
      <section
        className="py-[60px] md:py-[80px] relative"
        style={{
          background: 'linear-gradient(135deg, #0a0a14 0%, #0c2255 50%, #0a0a14 100%)',
        }}
      >
        <div className="absolute inset-0 bg-[#0a0a14]/85" />
        <div className="relative z-10 max-w-[1200px] mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-[28px] md:text-[34px] font-bold text-white mb-3 leading-tight">
            {siteData.benefitSection.title}
          </h2>
          <h3 className="text-lg md:text-xl text-white/80 font-medium mb-6">
            {siteData.benefitSection.subtitle}
          </h3>
          <p className="text-[15px] text-white/70 leading-[1.8] max-w-[900px] mx-auto">
            {siteData.benefitSection.text}
          </p>
        </div>
      </section>

      {/* Support Section */}
      <div id="servizi">
      <ContentSection
        title={siteData.supportSection.title}
        subtitle={siteData.supportSection.subtitle}
        paragraphs={[siteData.supportSection.text]}
        image={siteData.supportSection.image}
        imageAlt={siteData.supportSection.imageAlt}
        imageLeft={false}
        subtitleBlue
      />
      </div>

      {/* Three Steps */}
      <ThreeSteps />

      {/* Principles */}
      <Principles />

      {/* Guide Section */}
      {siteData.guideSections.map((section) => (
        <ContentSection
          key={section.id}
          title={section.title}
          paragraphs={section.paragraphs}
          image={section.image}
          imageAlt={section.imageAlt}
          imageLeft={section.imageLeft}
          isQuote={section.isQuote}
        />
      ))}

      {/* Blue Section - Learn step by step */}
      <section className="bg-[#0E47B0]">
        <div className="py-[60px]">
          <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              <div className="w-full lg:w-7/12">
                <h2 className="text-[28px] md:text-[34px] font-bold text-white mb-4 leading-tight">
                  {siteData.blueSection.title}
                </h2>
                {siteData.blueSection.paragraphs.map((p, i) => (
                  <p key={i} className="text-[15px] text-white/80 leading-[1.8] mb-4">{p}</p>
                ))}
              </div>
              <div className="w-full lg:w-5/12 text-center">
                <img
                  src={siteData.blueSection.image}
                  alt={siteData.blueSection.imageAlt}
                  className="w-full max-w-[500px] h-auto mx-auto rounded-lg"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Sub sections 2x2 grid */}
        <div className="pb-[60px]">
          <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {siteData.blueSection.subSections.map((sub, i) => (
                <div key={i} className="mb-4">
                  <h3 className="text-[18px] font-bold text-white mb-2">{sub.title}</h3>
                  <p className="text-[14px] text-white/70 leading-[1.8]">{sub.text}</p>
                </div>
              ))}
            </div>
            <div className="text-center mt-6">
              <a
                href="#form-main"
                className="inline-block px-8 py-3.5 bg-white text-[#0E47B0] font-bold text-sm tracking-wider rounded-lg hover:bg-white/90 transition-colors no-underline"
              >
                {siteData.blueSection.ctaText}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* More Sections */}
      {siteData.moreSections.map((section) => (
        <ContentSection
          key={section.id}
          title={section.title}
          paragraphs={section.paragraphs}
          image={section.image}
          imageAlt={section.imageAlt}
          imageLeft={section.imageLeft}
          isQuote={section.isQuote}
        />
      ))}

      {/* Blue Section 2 - Simple actions */}
      <section className="py-[60px] bg-[#0E47B0]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12">
            <div className="w-full lg:w-7/12">
              <h2 className="text-[28px] md:text-[34px] font-bold text-white mb-4 leading-tight">
                {siteData.blueSection2.title}
              </h2>
              {siteData.blueSection2.paragraphs.map((p, i) => (
                <p key={i} className="text-[15px] text-white/80 leading-[1.8] mb-4">{p}</p>
              ))}
            </div>
            <div className="w-full lg:w-5/12 text-center">
              <img
                src={siteData.blueSection2.image}
                alt={siteData.blueSection2.imageAlt}
                className="w-full max-w-[540px] h-auto mx-auto rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Awareness Section */}
      <section className="py-[60px]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="w-full lg:w-7/12">
              <h2 className="text-[28px] md:text-[34px] font-bold text-[#1a1a2e] mb-4 leading-tight">
                {siteData.awarenessSection.title}
              </h2>
              {siteData.awarenessSection.paragraphs.map((p, i) => (
                <p key={i} className="text-[15px] text-[#4a4a6a] leading-[1.8] mb-4">{p}</p>
              ))}
            </div>
            <div className="w-full lg:w-5/12 text-center">
              <img
                src={siteData.awarenessSection.image}
                alt={siteData.awarenessSection.imageAlt}
                className="w-full max-w-[500px] h-auto mx-auto rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Border Items */}
      <section className="pb-[60px]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            {siteData.borderItems.map((item, i) => (
              <div
                key={i}
                className="p-6 md:p-8 border border-gray-200"
              >
                <h3 className="text-[18px] font-bold text-[#1a1a2e] mb-3">{item.title}</h3>
                <p className="text-[14px] text-[#4a4a6a] leading-[1.8]">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
              href="#form-main"
              className="inline-block px-8 py-3.5 bg-gradient-to-r from-[#0E47B0] to-[#1a5dd4] hover:from-[#0d3d96] hover:to-[#1650b8] text-white font-bold text-sm tracking-wider rounded-lg transition-all no-underline"
            >
              {siteData.borderCtaText}
            </a>
          </div>
        </div>
      </section>

      {/* Acumen Section */}
      <section className="py-[60px] relative">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-full lg:w-5/12">
              <img
                src={siteData.acumenSection.image}
                alt={siteData.acumenSection.imageAlt}
                className="w-full max-w-[708px] h-auto rounded-lg"
                loading="lazy"
              />
            </div>
            <div className="w-full lg:w-7/12 lg:pl-8">
              <h2 className="text-[28px] md:text-[34px] font-bold text-[#1a1a2e] mb-4 leading-tight">
                {siteData.acumenSection.title}
              </h2>
              {siteData.acumenSection.paragraphs.map((p, i) => (
                <p key={i} className="text-[15px] text-[#4a4a6a] leading-[1.8] mb-4">{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <FAQ />

      {/* Highlights */}
      <HighlightsTable />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
